import { Text, useColorModeValue } from '@chakra-ui/react';
import { format, parseISO } from 'date-fns';
import ReactApexChart from 'react-apexcharts';
import Card from '../../../components/card/Card';
import { useAppSelector } from '../../../store/hooks';
import { RootState } from '../../../store/store';

/** Leads entregues por dia. É o "quanto está chegando" que o cliente acompanha. */
export default function VolumeChart() {
	const daily = useAppSelector((state: RootState) => state.liveLead.daily);
	const textColor = useColorModeValue('navy.700', 'white');
	const subColor = useColorModeValue('secondaryGray.700', 'secondaryGray.500');

	const categories = daily.map(d => format(parseISO(d.day), 'dd/MM'));
	const values = daily.map(d => d.total);

	return (
		<Card p='20px'>
			<Text fontSize='lg' fontWeight='bold' color={textColor} mb='4px'>
				Leads recebidos por dia
			</Text>
			<Text fontSize='sm' color={subColor} mb='16px'>
				Últimos {daily.length || 14} dias
			</Text>
			{daily.length === 0 ? (
				<Text fontSize='sm' color={subColor}>
					Nenhuma entrega no período.
				</Text>
			) : (
				<ReactApexChart
					type='bar'
					height={260}
					series={[{ name: 'Leads', data: values }]}
					options={{
						chart: { toolbar: { show: false } },
						dataLabels: { enabled: false },
						xaxis: { categories, labels: { style: { colors: subColor } } },
						yaxis: { labels: { style: { colors: subColor } } },
						grid: { strokeDashArray: 4 },
						colors: ['#4318FF'],
						plotOptions: { bar: { borderRadius: 6, columnWidth: '45%' } },
						tooltip: { y: { formatter: (v: number) => `${v} lead(s)` } }
					}}
				/>
			)}
		</Card>
	);
}
